import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import DetailListItem from 'Components/ComponentLibrary/Organisms/DetailItemsList/DetailListItem';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
});

const TransferList = ({
  className,
  classes,
  cancelableTransfers,
  nonCancelableTransfers,
}) => {
  if (cancelableTransfers.resources().length() === 0 && nonCancelableTransfers.resources().length() === 0) {
    return null;
  }

  let transfersToRender = cancelableTransfers;
  if (nonCancelableTransfers.resources().length() > 0) {
    transfersToRender = nonCancelableTransfers;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Text
        className={classes.title}
        text={'Pending Transfers'}
        variant="h3"
        align={'left'}
      />
      <List1
        className={classes.list}
      >
        {transfersToRender.resources().list().map((transfer) => {
          return (
            <DetailListItem
              key={transfer.id()}
              resource={transfer}
              disabled
            />
          );
        })}
      </List1>
    </Box>
  );
};

TransferList.defaultProps = {
  className: '',
};

TransferList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  cancelableTransfers: PropTypes.object.isRequired,
  nonCancelableTransfers: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransferList);
